import React, { useState } from 'react';
import './OhipAgentTypePicker.css';

const OhipLovPicker = ({ fetchFn, title, emptyMsg, onSelect, onSelectItem }) => {
    const [open, setOpen]       = useState(false);
    const [loading, setLoading] = useState(false);
    const [items, setItems]     = useState([]);
    const [error, setError]     = useState(null);

    const handleOpen = async () => {
        setError(null);
        setOpen(true);
        // Always refetch. This used to `return` early when items were already loaded, which meant the
        // second and every later click on "Fetch from Opera Cloud" issued NO request and silently served
        // a cached list — a fetch button that does not fetch, and indistinguishable from a fetch that
        // returned the same data. These are manual config screens, not a hot path, so one LOV call per
        // open is the right trade for the list always being current.
        setLoading(true);
        try {
            const res = await fetchFn();
            setItems(res.data?.items || []);
        } catch (err) {
            setError(err.response?.data?.error?.message || 'Failed to fetch from OHIP');
        } finally {
            setLoading(false);
        }
    };

    const handleSelect = (item) => {
        if (onSelectItem) onSelectItem(item);
        else onSelect(item.code);
        setOpen(false);
    };

    return (
        <>
            <button type="button" className="oatp-btn" onClick={handleOpen}>
                Fetch from Opera Cloud
            </button>

            {open && (
                <div className="oatp-backdrop" onClick={() => setOpen(false)}>
                    <div className="oatp-modal" onClick={e => e.stopPropagation()}>
                        <div className="oatp-modal-header">
                            <span className="oatp-modal-title">{title}</span>
                            <button type="button" className="oatp-close" onClick={() => setOpen(false)}>×</button>
                        </div>
                        <div className="oatp-modal-body">
                            {loading && <p className="oatp-status">Fetching from OHIP...</p>}
                            {error   && <p className="oatp-error">{error}</p>}
                            {!loading && !error && items.length === 0 && (
                                <p className="oatp-status">{emptyMsg}</p>
                            )}
                            {!loading && items.map((item, i) => (
                                <button
                                    // Indexed: OHIP can return the same code twice at different config
                                    // scopes (authorization rules are scoped by room class / rate category),
                                    // and a duplicate React key would drop the second row.
                                    key={`${item.code}-${i}`}
                                    type="button"
                                    className="oatp-item"
                                    onClick={() => handleSelect(item)}
                                >
                                    <span className="oatp-item-code">{item.code}</span>
                                    {item.description && item.description !== item.code && (
                                        <span className="oatp-item-desc">{item.description}</span>
                                    )}
                                    {item.scope && <span className="oatp-item-scope">{item.scope}</span>}
                                    {/* Shown only when the LOV carries one (authorization rules do; routing
                                        instructions, payment methods and rate codes do not), so this stays
                                        additive for every other picker sharing this component. */}
                                    {item.amount != null && item.amount !== '' && (
                                        <span className="oatp-item-amount">{item.amount}</span>
                                    )}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default OhipLovPicker;
